import React from 'react';

import links from '../../../../config/links';
import { IMAGES } from '../constants';
import fableticsStyles from './fableticsUpgradeCreative.scss';
import styles from './globalPrivilegesUpgradeCreative.scss';

// Non-US free viewers' creative for the Upgrade-to-Power popup. Reuses the
// two-panel travel image from the Fabletics member creative but drops all
// Fabletics branding — Fabletics is US-only, so non-US users only ever see the
// Global Privileges travel value here.
const GlobalPrivilegesUpgradeCreative = () => {
    const handleLearnMoreClick = () => {
        window.open(links.powerPlayersPage, '_blank', 'noopener,noreferrer');
    };

    return (
        <div
            className={styles.globalPrivilegesUpgradeCreative}
            data-testid="global-privileges.upgrade-creative.container"
        >
            <div className={fableticsStyles.imagePanels}>
                <div
                    className={fableticsStyles.imagePanel}
                    data-testid="global-privileges.upgrade-creative.image-airport"
                >
                    <img
                        src={IMAGES.airport}
                        alt="Tennis player at airport with UTR Sports bag"
                        className={fableticsStyles.imagePanelImg}
                        data-testid="global-privileges.upgrade-creative.image-airport.img"
                    />
                </div>
                <div
                    className={fableticsStyles.imagePanel}
                    data-testid="global-privileges.upgrade-creative.image-tennis"
                >
                    <img
                        src={IMAGES.tennisWomen}
                        alt="Two tennis players walking on a tennis court"
                        className={fableticsStyles.imagePanelImg}
                        data-testid="global-privileges.upgrade-creative.image-tennis.img"
                    />
                </div>
            </div>
            <p className={styles.caption} data-testid="global-privileges.upgrade-creative.caption">
                {'Sign up for a Power annual plan and get '}
                <span className={styles.emphasis} data-testid="global-privileges.upgrade-creative.caption-emphasis">$250 in travel value</span>
                {' instantly.'}
            </p>
            <button
                type="button"
                className={styles.learnMore}
                onClick={handleLearnMoreClick}
                data-testid="global-privileges.upgrade-creative.learn-more"
            >
                <span className={styles.underline} data-testid="global-privileges.upgrade-creative.learn-more-link">Learn more</span>
                {' about Global Privileges'}
            </button>
        </div>
    );
};

export default GlobalPrivilegesUpgradeCreative;
